// Import angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Import pipes
import { ComponentsModule } from '../components/components.module';
import { PipesModule } from '../pipes/pipes.module';

// Import components
import { PagedLineTableComponent } from './paged-line-table/paged-line-table.component';
import { CategoryRowComponent } from './category-row/category-row.component';
import { SubCategoryRowComponent } from './sub-category-row/sub-category-row.component';
import { LineRowComponent } from './line-row/line-row.component';
import { InputCellComponent } from './cell/input-cell/input-cell.component';
import { CurrencyInputCellComponent } from './cell/currency-input-cell/currency-input-cell.component';
import { DropdownCellComponent } from './cell/dropdown-cell/dropdown-cell.component';
import { MultiLineTextInputCellComponent } from './cell/multi-line-text-input-cell/multi-line-text-input-cell.component';

import { TailTableComponent } from './tail-table/tail-table.component';
import { TailRowComponent as TailLineRowComponent } from './tail-table/line-row/line-row.component';
import { IntermediateTotalRowComponent as TailIntermediateTotalRowComponent } from './tail-table/intermediate-total-row/intermediate-total-row.component';

// Import pipes
import { FormatCellValuePipe } from './pipes/format-cell-value.pipe';
import { TotalRowComponent } from './total-row/total-row.component';
import { SubCategoryTotalRowComponent } from './sub-category-total-row/sub-category-total-row.component';
import { TextCellComponent } from './cell/text-cell/text-cell.component';
import { TagsCellComponent } from './cell/tags-cell/tags-cell.component';
import { CommentCellComponent } from './cell/comment-cell/comment-cell.component';
import { HeaderCellComponent } from './cell/header-cell/header-cell.component';
import { TextLineElementDirective } from '../directives/text-line-element.directive';

@NgModule({
    declarations: [
        PagedLineTableComponent,
        CategoryRowComponent,
        SubCategoryRowComponent,
        LineRowComponent,
        InputCellComponent,
        CurrencyInputCellComponent,
        DropdownCellComponent,
        MultiLineTextInputCellComponent,
        FormatCellValuePipe,
        TailTableComponent,
        TailLineRowComponent,
        TailIntermediateTotalRowComponent,
        TotalRowComponent,
        SubCategoryTotalRowComponent,
        TextCellComponent,
        TagsCellComponent,
        CommentCellComponent,
        HeaderCellComponent,
        TextLineElementDirective,
    ],
    providers: [
        FormatCellValuePipe
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        PipesModule,
        FormsModule
    ],
    exports: [
        PagedLineTableComponent, TailTableComponent, TextLineElementDirective
    ]
})
export class TablesModule { }
